import React from 'react';
import NavSection from './NavSection';
import { dataManagerMenuItems } from './menuItems';

const DataManagerNav = ({ isOpen, expandedSections, onToggleSection, onNavClick }) => {
    return (
        <NavSection
            isOpen={isOpen}
            sectionKey="dashboards"
            sectionLabel="Data Manager"
            sectionSubtext="Coming soon"
            menuItems={dataManagerMenuItems.dashboard}
            isExpanded={expandedSections.dashboards}
            onToggle={onToggleSection}
            onNavClick={onNavClick}
        />
    );
};

export default DataManagerNav;